import React from 'react'
import { Card, CardContent, Skeleton } from '@mui/material'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'

const CustomCardContent = styled(CardContent)(() => ({
  padding: '8px 12px',
  '&:last-child': {
    paddingBottom: 8,
  },
}))

const CustomSkeleton = ({ xs }) => (
  <Grid size={xs}>
    <Skeleton variant="text" />
  </Grid>
)

CustomSkeleton.propTypes = {
  xs: PropTypes.number,
}

const LoadingServiceCard = () => {
  return (
    <Card variant="outlined">
      <CustomCardContent>
        <Grid container justifyContent="space-between" wrap="nowrap" size={12}>
          <CustomSkeleton xs={4} />
          <CustomSkeleton xs={2} />
        </Grid>
        <Grid container justifyContent="space-between" size={12}>
          <CustomSkeleton xs={8} />
          <CustomSkeleton xs={2} />
        </Grid>
        <Grid container alignItems="center" size={12}>
          <CustomSkeleton xs={8} />
        </Grid>
      </CustomCardContent>
    </Card>
  )
}

export default LoadingServiceCard
